export default __webpack_public_path__ + "static/media/MeatballSub.e142a853.jpg";